import { render } from "./help-menu.vue?vue&type=template&id=8f35e17a&ts=true"
import script from "./help-menu.ts?vue&type=script&lang=ts&external"
export * from "./help-menu.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__